/**
 * 应用入口文件
 * @description 初始化 Vue 应用，配置插件和全局组件
 */

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import config from '@/config';
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

// 引入公共样式
import '@/assets/styles/common.css';

// 引入 ECharts 组件
import { EchartLine, EchartPie } from '@/components/eChart';

// 注册 ECharts 组件为全局组件
Vue.component('EchartLine', EchartLine);
Vue.component('EchartPie', EchartPie);

// 使用 View UI 组件库
Vue.use(ViewUI, {
    transfer: true,
    size: 'default'
});

// 配置生产环境提示
Vue.config.productionTip = false;

// 将配置信息挂载到 Vue 实例
Vue.prototype.$config = config;

// 开发环境打印配置信息
if (process.env.NODE_ENV === 'development') {
    console.log('🔧 开发环境配置:', config);
}

// 创建 Vue 实例
new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app');

// 监听全局错误
Vue.config.errorHandler = (err, vm, info) => {
    console.error('❌ 全局错误:', err);
    console.error('❌ 错误组件:', vm);
    console.error('❌ 错误详情:', info);
};

// 警告信息处理
Vue.config.warnHandler = (msg, vm, trace) => {
    console.warn('⚠️ 警告:', msg);
    console.warn('⚠️ 组件链路:', trace);
};
